module.exports = {"650522100":"伊吾镇","650522101":"淖毛湖镇","650522102":"盐池镇","650522201":"苇子峡乡","650522202":"下马崖乡","650522204":"吐葫芦乡","650522205":"前山哈萨克民族乡","650522400":"伊吾县工业加工区","650522500":"兵团淖毛湖农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650522.json
// module id = 2851
// module chunks = 0